export default "__VITE_ASSET__BvMmS5kM__"